module.exports = __webpack_public_path__ + "img/report-active.092ec66e.svg";